/* eslint-disable no-bitwise */
/* tslint:disable no-bitwise */

export const normalizeColor = (color: string) => {
    let hex = String(color).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 3 || hex.length > 6) {
        return color;
    }
    if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    return hex;
};

export const getRGB = (decimalValue: number): [number, number, number] => {
    const R = decimalValue >> 16;
    const G = (decimalValue >> 8) & 0x00ff;
    const B = decimalValue & 0x0000ff;
    return [R, G, B];
};

/* tslint:disable max-line-length no-bitwise */
/**
 * Shade
 * @param {string} color - hex string
 * @param {number} number - floating point value between -1 (darkest) and 1 (lightest)
 *
 * @see {@link https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors}
 */
/* tslint:enable max-line-length no-bitwise */
export const shade = (color: string | null, percent: number): string | undefined => {
    if (!color) {
        return;
    }
    if (percent === 0) {
        return color;
    }

    const relativeColor = percent < 0 ? 0 : 255;
    const signedPercent = percent < 0 ? percent * -1 : percent;

    const hex = normalizeColor(color);
    const [R, G, B] = getRGB(parseInt(hex, 16));

    return (
        0x1000000 +
        (Math.round((relativeColor - R) * signedPercent) + R) * 0x10000 +
        (Math.round((relativeColor - G) * signedPercent) + G) * 0x100 +
        (Math.round((relativeColor - B) * signedPercent) + B)
    )
        .toString(16)
        .slice(1);
};

/**
 * getLuminance
 *  returns color luminance on a scale of 0 (darkest) to 255 (lightest)
 * @param color - hex string
 */
export const getLuminance = (color: string): number => {
    const hex = normalizeColor(color);
    const [R, G, B] = getRGB(parseInt(hex, 16));
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
};

/**
 * getRelativeTextColor
 *  returns black or white depending on color luminance
 * @param color - hex string
 */
export const getRelativeTextColor = (color: string | null): string | undefined => {
    if (!color) {
        return;
    }
    return getLuminance(color) / 255 > 0.5 ? '#000000' : '#FFFFFF';
};
